const hostname = "https://enquirybackend.tcc-technology.com"
// const hostname = 'http://localhost:3000'
module.exports = {
    domain: hostname
}